<!doctype html>
<html lang="en">

<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>XrossOver – Quick Start</title>
</head>

<body>
  <header class="header container">
    <img class="logo" src="assets/logos/logo-01.png" alt="XrossOver logo" width="200px" />
  </header>
  <section class="container">
    <div class="card center">
      <div class="eyebrow">Quick Start</div>
      <h1 class="title">Welcome to the<br />XrossOver family</h1>
      <p class="lead">
        Have your <b>vest code</b> handy. Choose where you want to download the app and then watch
        the short setup video below
      </p>
      <div class="stores">
        <a class="btn btn--apple" href="https://apps.apple.com/gt/app/xover-trainer/id1640546882" aria-label="Download on the App Store">
          <div class="icon flex flex-col h-[40px] w-[40px] items-center justify-center rounded-full">
            <i-tabler name="brand-apple" class="icon-size"></i-tabler>
          </div>
          <span>App Store</span>
        </a>
        <span class="btn btn--google" aria-disabled="true">
          <div class="icon flex flex-col h-[40px] w-[40px] items-center justify-center rounded-full">
            <i-tabler name="brand-android" class="icon-size"></i-tabler>
          </div>
          <span>Google Play<br /><span class="btn__small">Coming soon</span></span>
        </span>
      </div>
      <p class="note">
        The app is free to use with optional upgrades. If you're under 13, a parent or guardian will
        need to subscribe on your behalf.
      </p>
      <div class="video-wrap">
        <div class="ratio">
          <iframe src="https://www.youtube.com/embed/zdviDuS_hPA" title="Setup video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
          </iframe>
        </div>
      </div>
    </div>
  </section>
  <footer class="container">
    © {{currentYear}} XrossOver Sports. All rights reserved.
  </footer>
</body>

</html>